<template>
<div class="preloader" v-show="preloader">
    <img src="/loading3.gif" alt="Preloader..." >
    <div class="">
        Cargando...
    </div>
</div>
    
</template>
<script>

export default {
    name:'preloader',
    computed: {
        preloader(){
            return this.$store.state.preloader.loading
        }
    }
}
</script>

<style  scoped>
.preloader{
background:#000;
position: absolute;
z-index: 9999;
opacity: .2;
width: 100%;
height: 100%;
margin: 0;
text-align: center;
padding: 20% 0
}
.preloader img{
    max-width: 100%
}
</style>